export default __webpack_public_path__ + "static/media/campus.d57e7c88.jpg";